import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { usePromptResponseChooser } from '../components/PromptResponseChooser';
import api from '../api';
import { PageTitle, LoadingText } from '../components/Style';

var Container = styled.div`
  max-width: 410px;
  margin: 0 auto;
  padding: 1em 0.75em 2em;
  display: flex;
  flex-direction: column;
  gap: 1em;
  align-items: center;
`;

var PromptCard = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 400px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: white;
  border: 1px solid #ddd;
  border-right-width: 2px;
  border-bottom-width: 2px;
  border-radius: 12px;
`;

var PromptName = styled.div`
  font-size: 0.7rem;
  font-weight: 700;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 0.5em;
`;

var PromptText = styled.div`
  font-weight: 800;
  font-size: 1rem;
  margin-bottom: 0.35em;
`;

var PromptMeta = styled.div`
  color: #777;
  font-size: 0.85rem;
  line-height: 1.4;
  margin-bottom: 1em;
`;

var ButtonRow = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

var PrimaryButton = styled(Link)`
  display: inline-block;
  background: black;
  color: white;
  border: none;
  font-family: inherit;
  cursor: pointer;
  text-decoration: none;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 0.55em 1.5em;
  border-radius: 8px;

  &:hover {
    background: #333;
  }
`;

var SecondaryButton = styled(Link)`
  display: inline-block;
  background: white;
  color: black;
  text-decoration: none;
  border: 1px solid black;
  border-right-width: 2px;
  border-bottom-width: 2px;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 0.55em 1.5em;
  border-radius: 8px;

  &:hover {
    background: #f5f5f5;
  }
`;

var ActiveBadge = styled.span`
  display: inline-block;
  background: #22c55e;
  color: white;
  font-size: 0.65rem;
  font-weight: 700;
  padding: 0.15em 0.5em;
  border-radius: 4px;
  margin-left: 0.5em;
  vertical-align: middle;
`;

var EmptyMessage = styled.p`
  text-align: center;
  color: #999;
  margin-top: 2rem;
  font-size: 0.9rem;
`;

export default function Prompts() {
  var respond = usePromptResponseChooser();
  useEffect(function () {
    document.title = 'Prompts | HeavyRotation';
  }, []);

  var _prompts = useState([]);
  var prompts = _prompts[0];
  var setPrompts = _prompts[1];

  var _loading = useState(true);
  var loading = _loading[0];
  var setLoading = _loading[1];

  useEffect(function () {
    api
      .get('/api/prompts')
      .then(function (res) {
        setPrompts(res.data || []);
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
      });
  }, []);

  if (loading) return <LoadingText>Loading...</LoadingText>;

  return (
    <Container>
      <PageTitle>Prompts</PageTitle>
      {prompts.length === 0 ? (
        <EmptyMessage>No prompts yet. Check back soon!</EmptyMessage>
      ) : (
        prompts.map(function (prompt) {
          return (
            <PromptCard key={prompt.id}>
              {prompt.name && <PromptName>{prompt.name}</PromptName>}
              <PromptText>{prompt.text}</PromptText>
              <PromptMeta>
                {prompt.responseCount > 0
                  ? prompt.responseCount + (prompt.responseCount === 1 ? ' response' : ' responses')
                  : 'No responses yet'}
              </PromptMeta>
              <ButtonRow>
                <PrimaryButton as="button" type="button" {...respond.triggerProps(prompt.id)}>
                  Respond
                </PrimaryButton>
                {prompt.responseCount > 0 && (
                  <SecondaryButton to={'/prompts/' + prompt.id}>See Responses</SecondaryButton>
                )}
              </ButtonRow>
            </PromptCard>
          );
        })
      )}
      {respond.chooser}
    </Container>
  );
}
